import { render, staticRenderFns } from "./TelegramNewsletters.vue?vue&type=template&id=41885f22&scoped=true"
import script from "./TelegramNewsletters.vue?vue&type=script&lang=js"
export * from "./TelegramNewsletters.vue?vue&type=script&lang=js"
import style0 from "./TelegramNewsletters.vue?vue&type=style&index=0&id=41885f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41885f22",
  null
  
)

export default component.exports